module.exports = __webpack_public_path__ + "img/ic-lineplot-diamond.8fcbe1e2.svg";